import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import styles from '../styles/emptyState.module.scss';

const EmptyState = ({ body, title, actions = null, testId = '', containerProps = {} }) => (
  <div className={styles.element} data-testid={testId} {...containerProps}>
    <Typo className={styles.heading} element="span" variant="d03">
      {title}
    </Typo>
    <Typo className={styles.description} color="secondary" element="span" variant="b02">
      {body}
    </Typo>
    <div className={styles.actions}>{actions}</div>
  </div>
);

EmptyState.propTypes = {
  actions: PropTypes.node,
  body: PropTypes.string.isRequired,
  testId: PropTypes.string,
  title: PropTypes.string.isRequired,
  containerProps: PropTypes.shape({
    'data-blocktype': PropTypes.string,
  }),
};

export default React.memo(EmptyState);
